/**
 * Lazy loaded components for better initial load performance
 * Components are loaded on-demand after initial render
 */
import { lazy, Suspense } from 'react';
import { 
  MarketsListSkeleton, 
  ChartSkeleton, 
  TechnicalIndicatorsSkeleton,
  ToolsRowSkeleton,
  NewsSkeleton,
  PortfolioSkeleton,
  ZoneDividerSkeleton
} from './ui/skeleton-loaders';

// Lazy load heavy components
const DashboardZones = lazy(() => import('./DashboardZones'));
const MarketNews = lazy(() => import('./MarketNews'));
const PortfolioSummary = lazy(() => import('./PortfolioSummary'));
const AdvancedBacktesting = lazy(() => import('./AdvancedBacktesting'));
const SectorAnalysis = lazy(() => import('./SectorAnalysis'));
const CorrelationAnalysis = lazy(() => import('./CorrelationAnalysis'));
const TradingJournal = lazy(() => import('./TradingJournal'));
const DividendCalendar = lazy(() => import('./DividendCalendar'));
// Nuevos componentes
const HistorialMaxMin = lazy(() => import('./HistorialMaxMin'));
const CorrelationHeatmap = lazy(() => import('./CorrelationHeatmap'));

// Wrapper component with suspense fallback
export const LazyDashboardZones = (props) => (
  <Suspense fallback={
    <div className="space-y-4 lg:space-y-6">
      <ZoneDividerSkeleton />
      <MarketsListSkeleton />
      <ZoneDividerSkeleton />
      <ChartSkeleton />
      <TechnicalIndicatorsSkeleton />
      <ToolsRowSkeleton />
      <ZoneDividerSkeleton />
      <NewsSkeleton />
      <ZoneDividerSkeleton />
      <PortfolioSkeleton />
    </div>
  }>
    <DashboardZones {...props} />
  </Suspense>
);

export const LazyMarketNews = (props) => (
  <Suspense fallback={<NewsSkeleton />}>
    <MarketNews {...props} />
  </Suspense>
);

export const LazyPortfolioSummary = (props) => (
  <Suspense fallback={<PortfolioSkeleton />}>
    <PortfolioSummary {...props} />
  </Suspense>
);

export const LazyAdvancedBacktesting = (props) => (
  <Suspense fallback={<ToolsRowSkeleton />}>
    <AdvancedBacktesting {...props} />
  </Suspense>
);

export const LazySectorAnalysis = (props) => (
  <Suspense fallback={<ToolsRowSkeleton />}>
    <SectorAnalysis {...props} />
  </Suspense>
);

export const LazyCorrelationAnalysis = (props) => (
  <Suspense fallback={<ToolsRowSkeleton />}>
    <CorrelationAnalysis {...props} />
  </Suspense>
);

export const LazyTradingJournal = (props) => (
  <Suspense fallback={<ToolsRowSkeleton />}>
    <TradingJournal {...props} />
  </Suspense>
);

export const LazyDividendCalendar = (props) => (
  <Suspense fallback={<ToolsRowSkeleton />}>
    <DividendCalendar {...props} />
  </Suspense>
);

// Nuevos componentes lazy
export const LazyHistorialMaxMin = (props) => (
  <Suspense fallback={<ToolsRowSkeleton />}>
    <HistorialMaxMin {...props} />
  </Suspense>
);

export const LazyCorrelationHeatmap = (props) => (
  <Suspense fallback={<ToolsRowSkeleton />}>
    <CorrelationHeatmap {...props} />
  </Suspense>
);

export { DashboardZones };
export default LazyDashboardZones;
